import React, { useState } from 'react';
import StartScreen from './components/StartScreen';
import AuditScreen from './components/AuditScreen';
import ResultScreen from './components/ResultScreen';
import './App.css';

function App() {
  const [currentScreen, setCurrentScreen] = useState('start');
  const [formData, setFormData] = useState({ ticketPromedio: 0, leadsMenuales: 0 });
  const [auditAnswers, setAuditAnswers] = useState({
    fuentes_trafico: null,
    formularios_integrados: null,
    crm_centralizado: null,
    velocidad: null,
    persistencia: null,
    multicanal_automatizado: null,
    agenda_automatica: null,
    scripts_estandarizados: null,
    recordatorios_automaticos: null,
    base_segmentada: null,
    seguimiento_postventa: null,
    referidos_automatizados: null
  });

  const handleFormSubmit = (data) => {
    setFormData(data);
    setCurrentScreen('audit');
  };

  const handleAuditSubmit = (answers) => {
    setAuditAnswers(answers);
    setCurrentScreen('result');
  };

  const goBack = () => {
    if (currentScreen === 'audit') {
      setCurrentScreen('start');
    } else if (currentScreen === 'result') {
      setCurrentScreen('audit');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-800 relative overflow-hidden">
      {/* Modern Tech Grid Background */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#4f46e5_1px,transparent_1px),linear-gradient(to_bottom,#4f46e5_1px,transparent_1px)] bg-[size:50px_50px] opacity-[0.05]"></div>
      
      {/* Floating orbs for depth */}
      <div className="absolute top-20 left-20 w-96 h-96 bg-blue-500 rounded-full filter blur-3xl opacity-[0.03] animate-pulse-slow"></div>
      <div className="absolute bottom-20 right-20 w-96 h-96 bg-indigo-500 rounded-full filter blur-3xl opacity-[0.03] animate-pulse-slow" style={{ animationDelay: '2s' }}></div>
      
      {/* Grid overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-slate-900/20 via-transparent to-slate-900/20"></div>
      
      <div className="relative z-10">
        {currentScreen === 'start' && <StartScreen onSubmit={handleFormSubmit} />}
        {currentScreen === 'audit' && (
          <AuditScreen 
            formData={formData} 
            onSubmit={handleAuditSubmit} 
            onBack={goBack} 
          />
        )}
        {currentScreen === 'result' && (
          <ResultScreen 
            formData={formData} 
            auditAnswers={auditAnswers} 
            onBack={goBack} 
          />
        )}
      </div>
    </div>
  );
}

export default App;